
import './App.css';
import './css/dashboard.css';
import './css/queue.css';
import './css/mainBody.css';
import * as amplitude from "@amplitude/analytics-browser";
import React, { useState, useEffect, useRef } from 'react';
import HeaderBar from './template/headerBar';
import TopBar from './template/topBar';
import LeadList from './template/leads/leads';
import ScheduledCalls from './template/scheduling/calls/scheduleCalls';
import ScheduledAppointment from './template/scheduling/appointment/scheduledAppt';
import WorkflowFollowup from './template/workflowFollowup';
import Teams from './template/team/team';
import SoftPhone from './template/phone/softPhone';
import { Device } from '@twilio/voice-sdk';
import AgentActivity from './template/activity/agentActivity';
import LeadCard from './template/leads/leadCard';
import AddLeads from './template/uploadLeads';
import Numbers from './template/number/number';
import Voicemail from './template/voicemail/voicemail';
import VoiceDrops from './template/voicemail/voiceDrop';
import CallForward from './template/callForwarding/callForward';
import TrustHub from './template/trust/trustHubMain';
import EmailTemplates from './template/templates/emailTemplates';
import Objection from './template/templates/objections';
import TextTemplates from './template/templates/textTemplates';
import Script from './template/templates/scripts';
import LeadStatus from './template/status/leadStatus';
import LeadTags from './template/tags/leadTags';
import WorkflowMain from './template/workflow/workflowMain';
import Integrations from './template/integrations/Integrations.js';
import FollowUp from './template/followUp/followUp';
import Market from './template/market/market';
import LeadType from './template/leadTypes/leadTypes';
import AgentSubscription from './template/subscription/agentSubscription';
import { fetchWithDefaults } from './config/fetchDefault';
import { getMarketInfo } from './utilities/marketUtil';
import { unixTommddyyyy, timestampConvert, unixTommddhia } from './utilities/dashFunction';
import QueueModule from './template/callQueue/queue';
import LeaderBoard from './template/leaderBoard/leaderBoard';
import Conversations from './template/conversations/convos';
import image from './assets/icons/loading-loader.gif';
import EmptyQueue from './template/dashboard/frontPageOptions/emptyQueue';
import QuilityParentBlock from './template/elements/quilityParentBlock';
import Overview from './template/kanban/overview';
import FreshChat from 'react-freshchat';
import FrontPremadeFilterBlock from './template/frontpage/frontPremadeFilterBlock.js';
import { fetchAppInformation, fetchFilterData, fetchActivity, setActiveFilter, saveTextingNumbers, getSubscriptionInfo, getConversations } from './utilities/appSetup';
import { useSelector, useDispatch } from 'react-redux';
import ConversationPreview from './template/frontpage/convoPreviewBlock.js';
import { setQueue, setBackup, setWholeQueue, updateSpecificLeadEntry, resetCalledQueue, setQueueSource } from './features/queueSlice';
import { setRefreshLogin } from './features/agentSlice';
import MissedCalls from './template/phone/missedCalls.js';
import { createBrowserHistory } from 'history';
import LoginPopup from './template/loginPopup.js';
import { captureCallError, resetCallError, setCall } from './features/callSlice.js';
import Tutorial from './template/tutorial/tutorial.js';
import InformationPopup from './template/popup/informationPopup.js';
import CallRecording from './template/recording/recording.js';
import Voicemails from './template/phone/voicemails.js';
import InfoAlert from './template/popup/infoAlert.js';
import SubscribeModal from './template/subscription/subscribeModal.js';
import Icon from './assets/icons/icon.js';
import { initIntercom } from './utilities/intercomChat.js';
import { fetchLeadDataThunk } from './features/leadDataInfoSlice.js';
import AgentProfile from './template/agent/agentProfile.js';
import { fetchCalendarThunk } from './features/calendarSlice.js';
import { isObjectEmpty, quilityParentBlockType } from './utilities/genericUtils.js';
import { fetchActivityThunk } from './features/scheduledCallSlice.js';
import { setIsCustomFilter } from './features/leadFilterSlice.js';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { removeAllFilters, updatePendingFilters, updatePredefinedFilter } from './features/leadTableFiltersSlice.js';
import { initZendesk } from './utilities/initZendesk.js';
import { getRecordingConfig } from './utilities/recordingFunctions.js';
import { setMicPermissionError, setMicPermissionModalLocked } from './features/callPermissionErrorSlice.js';
import ZendeskLauncher from './template/zendeskLauncher.js';

const history = createBrowserHistory();

function App({ currentQuery, load, auth, agentId, signOut, handleSetUnread, unreadMessages, newMessages }) {
    const { isAuthenticated } = useAuth0()
    const isFeature457Enabled = process.env.REACT_APP_FUNNEL_FEATURE_457 === 'true'
    const dispatch = useDispatch();
    const agentIdNumber = agentId;
    const popups = useSelector((state) => state.popups.popups);
    const agentInfo = useSelector((state) => state.agent.userData);
    const subscription = useSelector((state) => state.subscription.subscription);
    const agentAllappointmentData = useSelector((state) => state.scheduledCallInfo?.appointmentsArray);
    const totalScheduleCall = useSelector((state) => state.scheduledCallInfo.totalScheduleCall);
    const call = useSelector((state) => state.call.call);
    const refreshLogin = useSelector((state) => state.agent.refreshLogin);
    const queue = useSelector((state) => state.queue.queue);
    const missedCalls = useSelector((state) => state.missedCall.missedCall);
    const [callStatus, setCallStatus] = useState('closed');
    const [appInfo, setAppInfo] = useState([]);
    const [holdingQueue, setHoldingQueue] = useState(false);
    const [page, setPage] = useState(false);
    const [pathTitle, setPathTitle] = useState();
    const [subscribe, setSubscribe] = useState(false);
    const [callerId, setCallerId] = useState([]);
    const [isMin, setListMin] = useState(false);
    const [barState, setBarState] = useState(false);
    const [leadCard, setLeadCard] = useState([]);
    const [workParams, setWorkParams] = useState();
    const [infoAlert, setInfoAlert] = useState(false);
    const [twilioDevice, setTwilioDevice] = useState(false);
    // const [activity, setActivity] = useState(false);
    const [calledQueue, setCalledQueue] = useState([]);
    const [searchQueue, setSearchQueue] = useState(false);
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [textingNumbers, setTextingNumbers] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newAppt, setNewAppt] = useState(false);
    const [isActivityToggled, setIsActivityToggled] = useState(false);
    const [dialActivity, setDialActivity] = useState(false);
    const [marketData, setMarketData] = useState(false);
    const [batch, setBatch] = useState(false);
    const [renew, setRenew] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [bulkOpen, setBulkOpen] = useState(false);
    const [refreshQueue, setRefreshQueue] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(false);
    const [oneLoad, setOneLoad] = useState(false);
    const hasNumberLookupBeenCalledRef = useRef(false);
    const [permission, setPermission] = useState(false);
    const [hideBlockMsg, sethideBlockMsg] = useState(false);
	const [lastPathReqTsMs, setLastPathReqTsMs] = useState(0);
	useEffect(
		() => {
			setLastPathReqTsMs(Date.now());
		},
		[],
	)
    const selectedOptions = useSelector(state => state.filterSearch.selectedOptions)
    const calledLeadsQueue = useSelector((state) => state.queue.calledQueue);

    //  ===== leads popup full data =====
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);

    const activity = useSelector((state) => state.scheduledCallInfo.activityData);

    const handleActivityToggle = async (init) => {
        let period;
        if (init) {
            period = 'week'
        }
        else {
            setIsActivityToggled(prevState => !prevState);
            if (isActivityToggled) {
                period = 'week';
            }
            else {
                period = 'month';
            }
        }

        try {
            const response = await fetchWithDefaults(`/dialActivity?period=${period}&agent=${agentIdNumber}`);
            if (!response.ok) {
                setRenew(true);
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setDialActivity(jsonData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const componentMap = {
        //Tasks: TaskMain,
        'Scheduled Calls': ScheduledCalls,
        'Scheduled Appointments': ScheduledAppointment,
        'Workflow followup': WorkflowFollowup,
        Team: Teams,
        Activity: AgentActivity,
        'Add Leads': AddLeads,
        Number: Numbers,
        Voicemail: Voicemail,
        VoiceDrop: VoiceDrops,
        'Call Forwarding': CallForward,
        'Trust Hub': TrustHub,
        'Text Templates': TextTemplates,
        'Email Templates': EmailTemplates,
        Objections: Objection,
        Scripts: Script,
        'Lead Statuses': LeadStatus,
        Tags: LeadTags,
        Workflows: WorkflowMain,
        'Follow Ups': FollowUp,
        Subscription: AgentSubscription,
        Market: Market,
        'Lead Types': LeadType,
        'Integrations': Integrations,
        'Overview': Overview,
        'Call Recording': CallRecording,
        'Account': AgentProfile,
    };

    const ComponentToRender = componentMap[pathTitle] || LeadList;
    const clearQueue = async () => {
        try {
            const response = await fetchWithDefaults(
                `/clearQueue`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        agent: agentInfo.agentId,
                    })
                }
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const jsonData = await response.json()
            updateQueue([]);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleSoftPhone = (value) => {
        setCallStatus(value)
    }

    const openQueue = () => {
        dispatch(updateSpecificLeadEntry({id: leadsAlldata.lead_id, updatedLead: leadsAlldata}))
        setOpen(!open);
        setExpanded(false);
    }
    const handlingClearHolding = () => {
        setHoldingQueue(false);
    }
    const expandSession = () => {
        setExpanded(!expanded);
    }
    const jumpIntoQueue = () => {
        setOpen(!open);
        setExpanded(!expanded);
    }

    const openLead = async (leadId, from) => {
        setListMin(true);
        try {

            setLoading(true);
            //history(`/lead/${leadId}`);
            await dispatch(fetchLeadDataThunk({leadId}))
            setLeadCard([leadsAlldata]);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const changeBarState = () => {
        setBarState(!barState);
    }
    const numberLookup = async (number) => {
        setCallerId({ name: number, lead_id: null });
        try {
            const response = await fetchWithDefaults(`/numberLookup?agent=${agentIdNumber}&number=${number}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setCallerId(jsonData);

            hasNumberLookupBeenCalledRef.current = false;

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const setUpPhone = async () => {
        try {
            const response = await fetchWithDefaults(`/twilioToken?agent=${agentIdNumber}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const deviceOptions = {
                tokenRefreshMs: 10000,
                enableImprovedSignalingErrorPrecision: true, // provides more precise errors instead of using generic error code: https://www.twilio.com/docs/voice/sdks/javascript/twiliodevice#improved-signaling-errors
            }
            saveTextingNumbers(dispatch, jsonData[0].textingNumbers)
            setTextingNumbers(jsonData[0].textingNumbers);
            const device = new Device(jsonData[0].token, deviceOptions);
            device.register();
            device.addListener('registered', device => {
                console.log('The device is ready to receive incoming calls.')
            });

            device.on('incoming', call => {

                if (!hasNumberLookupBeenCalledRef.current) {
                    numberLookup(call.parameters.From);
                    hasNumberLookupBeenCalledRef.current = true; // Set the flag to true after the first call
                }

                setCallStatus(call.status());
                dispatch(setCall(call));
                call.on('cancel', () => {
                    setCallStatus('closed')
                });
            });

            device.on("error", async (error) => {
                console.error("Device Error:", error);

                if(error.code === 20104){
                    // this error code indicates that the token expired
                    // need to refresh the token to address this issue
                    const token = await getNewToken();
                    device.updateToken(token);
                    setTwilioDevice(device);
                } else {
                    dispatch(captureCallError({
                        errorCode: error.code,
                        errorMessage: error.explanation ?? error.message,
                        errorSolutions: error.solutions
                    }))
                }
            });

            device.on("connect", (connection) => {
                connection.on("error", async (error) => {
                    console.error("Call Error:", error);
                    console.log('call error', {error})

                    if(error.code === 20104){
                        // this error code indicates that the token expired
                        // need to refresh the token to address this issue
                        const token = await getNewToken();
                        device.updateToken(token);
                        setTwilioDevice(device);
                    } else {
                        dispatch(captureCallError({
                            errorCode: error.code,
                            errorMessage: error.explanation ?? error.message,
                            errorSolutions: error.solutions
                        }))
                    }
                });
            });

            device.on('tokenWillExpire', async () => {
                const token = await getNewToken();
                device.updateToken(token);
                setTwilioDevice(device);

            });
            setTwilioDevice(device);
        } catch (error) {
            console.error('Error fetching data:', error);
            signOut();
        }
    }
    const getNewToken = async () => {
        try {
            const response = await fetchWithDefaults(`/twilioToken?agent=${agentIdNumber}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            return jsonData[0].token;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    function maxList() {
        dispatch(updateSpecificLeadEntry({id: leadsAlldata.lead_id, updatedLead: leadsAlldata}))
        setListMin(false);
        setLeadCard([]);
        if(queue.length > 0){
            dispatch(fetchLeadDataThunk({leadId: queue[0].lead_id}));
        }
        // sethideBlockMsg(true);
        dispatch(resetCallError())
    }

    const [updateTrigger, setUpdateTrigger] = useState(0); // Force update
    const fetchPage = async (path,shouldNavigate = true) => {
        if (shouldNavigate) {
        history.push(`/${path}`, { forced: true });
        }

        const oldPath = path;
        setLoading(true);
        if (path === 'dash') {
            setPage(false);
            setLoading(false);
        }
        else if (path === 'syncLeads') {
            setPage(false);
            try {
                const response = await fetchWithDefaults(`/syncLeads?agent=${agentIdNumber}`);
                console.log(response.status)
                if (response.status === 401 || response.status === 403) {
                    dispatch(setRefreshLogin(true));
                    throw new Error('Network response was not ok');
                }
                const jsonData = await response.json();
                if (jsonData.message === 'refresh') {
                    const baseUrl = `${window.location.protocol}//${window.location.host}`;
                    window.location.href = `${process.env.REACT_APP_FUNNEL_AUTH_QUILITY}/authorize?response_type=code&client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}&redirect_uri=${baseUrl}/api/quility/authorize&scope=profile email offline_access read:Agents&audience=${process.env.REACT_APP_AUTH0_AUDIENCE}&state=${agentIdNumber}`;
                }
                setLoading(false);
                setInfoAlert({ title: "Your Lead sync is in process!", info: "This can take up to 10 minutes for all leads to process. Thank you for your patience" })
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        }
        else if (path==='Account') {
            setPage([{name: path, oldPath}])
            setPathTitle('Account')
            setLoading(false)
        }
        else {
            let pathExtension;
            if (path.substr(0, 5) == 'batch') {

                pathExtension = '?batch=' + path;
                path = 'Viewing_Batch';
            }
            else {
                pathExtension = `?agent=${agentIdNumber}&organization=${agentInfo.organization}`;
                path = path;
            }
            try {
                const response = await fetchWithDefaults('/' + path + pathExtension);
                if (response.status === 401 || response.status === 403) {
                    dispatch(setRefreshLogin(true));
                    throw new Error('Network response was not ok');
                }
                const jsonData = await response.json();
                if (jsonData.status == false) {
                    setPage([{ type: false }]);
                }
                else {
                    if (oldPath.substr(0, 5) == 'batch') {
                        setPage(jsonData);
                        setBatch(oldPath);
                    }
                    else {
                        setPage([...jsonData]);
                        // setPage(jsonData);
                         // Force state update even if data is the same
                        setUpdateTrigger((prev) => prev + 1);
                    }
                }
                setPathTitle(path.replace("_", " "));
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }

        }
	    switch (path) {
		    case "dash":
		    case "syncLeads":
		    case "Team":
		    case "Number":
		    case "Trust_Hub":
		    case "Account":
		    case "Market":
		    case "Integrations":
		    case "Subscription":
		    case "Scheduled_Calls":
		    case "Follow_Ups":
		    case "Voicemail":
		    case "Call_Recording":
		    case "Call_Forwarding":
		    case "VoiceDrop":
		    case "migrate/quility/activate":
		    case "signup": {
			    const dt = new Date();
				try {
					amplitude.track(
						"[Amplitude] Page Viewed",
						{
							Agent_code: agentInfo.agentCode,
							view_source: oldPath,
							duration: dt.valueOf() - lastPathReqTsMs,
						}
					);
				} catch (err) {
					console.error(
						"fetchPage: Exception occurred during Amplitude communication attempt: %s",
						err,
						err,
					);
				}
				setLastPathReqTsMs(dt.valueOf());
			    break;
		    }
	    }
    };

    const addToQueue = async (search, cat) => {
        setLoading(true);
        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    agent: agentIdNumber,
                    leadQuery: search,
                    cat: cat
                })
            };

            const response = await fetchWithDefaults('/addToQueue', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const updatedJsonData = jsonData.map((item, index) => ({
                ...item,
                queuePos: index
            }));
            updateQueue(updatedJsonData);
            setLoading(false);
            setHoldingQueue(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const replaceQueue = async (search) => {
        setLoading(true);

        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    agent: agentIdNumber,
                    leadQuery: search,
                })
            };
            const response = await fetchWithDefaults('/replaceQueue', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const updatedJsonData = jsonData.map((item, index) => ({
                ...item,
                queuePos: index
            }));
            updateQueue(updatedJsonData);
            setLoading(false);
            setHoldingQueue(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const addSelectedToQueue = async (leads) => {
        setLoading(true);

        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    agent: agentIdNumber,
                    leads: leads,
                })
            };

            const response = await fetchWithDefaults('/leadsToQueue', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const updatedJsonData = jsonData.map((item, index) => ({
                ...item,
                queuePos: index
            }));
            updateQueue(updatedJsonData);
            setLoading(false);
            setHoldingQueue(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const replaceSelectedToQueue = async (leads) => {
        setLoading(true);
        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    agent: agentIdNumber,
                    leads: leads,
                })
            };

            const response = await fetchWithDefaults('/replaceLeadsToQueue', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const updatedJsonData = jsonData.map((item, index) => ({
                ...item,
                queuePos: index
            }));
            updateQueue(updatedJsonData);
            setRefreshQueue(updatedJsonData[0])
            setLoading(false);
            setHoldingQueue(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }

    const fetchQueue = async () => {
        try {
            setActiveFilter('Last 90 Days', dispatch);

            const filterOptions = {}

            for (let index = 0; index < selectedOptions.length; index++) {
                const opn = selectedOptions[index];
                const key = opn.option

                if(!filterOptions[key]){
                    filterOptions[key] = []
                }

                filterOptions[key].push(opn.search)
            }

            const response = await fetchWithDefaults('/queue/callQueue',{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    agent: agentId,
                    filterOptions
                })
            })

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const {wholeQueue, queue} = jsonData

            dispatch(setQueueSource({
                endpoint:'/queue/callQueue',
                body: {
                    agent: agentId,
                }
            }))
            //dispatch(setQueue(queue ?? []));
            dispatch(setBackup(queue ?? []));
            dispatch(setWholeQueue(wholeQueue ?? []))
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {

        const runFunctions = async () => {
            try {

                setLoading(true);
                //await handleActivityToggle(true); // this sets the activity toggle to one week
                await setUpPhone(); // this sets up the phone, gathers twilio token as well as the textable phone numbers
                await getSubscriptionInfo(agentIdNumber, setSubscribe, dispatch);
                dispatch(fetchActivityThunk({ agentIdNumber })); // This gathers agents activity

                await fetchFilterData(dispatch, agentIdNumber); // this gathers the filters
                await fetchAppInformation(setAppInfo, dispatch, agentIdNumber, agentInfo.organization); // thisgathers the entire applications data - so things like statuses,templates, numbers, agent info ect.
                //await fetchQueue(); //this gathers the queue
                await getConversations(agentIdNumber, dispatch); // this gathers the texting convos
                await getMarketInfo(fetchWithDefaults, agentIdNumber, setMarketData); // gets the market data.
                dispatch(fetchCalendarThunk({agentId: agentInfo.agentId}))
            } catch (error) {
                console.error('Error running functions:', error);
            } finally {
                setLoading(false);
            }
        }
        //if the application information exists
        if (oneLoad) {
            if (isAuthenticated) {
                runFunctions();
                if (auth === 'gather') {
                    syncLeads();
                }
                else if (auth === 'authenticate') {
                    fetchPage("Integrations");
                }
            }
        }
        else {
            setOneLoad(true)
        }
    }, [renew, isAuthenticated, oneLoad,dispatch,agentIdNumber])
    const syncLeads = async () => {
        try {
            setLoading(true);
            const response = await fetchWithDefaults(`/syncLeads?agent=${agentIdNumber}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            if (jsonData.message === 'refresh') {
                const baseUrl = `${window.location.protocol}//${window.location.host}`;
                const audience = process.env.REACT_APP_HQ_AUTH0_AUDIENCE
                if (baseUrl)
                    window.location.href = `${process.env.REACT_APP_FUNNEL_AUTH_QUILITY}/authorize?response_type=code&client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}&redirect_uri=${baseUrl}/api/quility/authorize&scope=profile email offline_access read:Agents&audience=${process.env.REACT_APP_AUTH0_AUDIENCE}&state=${agentIdNumber}`;
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    }

    const handleUpdateQueueLead = (field, value, leadId) => {
        const updatedData = queue.map(item => {
            if (item.lead_id === leadId) {
                // Create a new object with the updated field
                return {
                    ...item, // Copy all existing properties of the item
                    [field]: value // Update the specified field
                };
            }
            return item;
        });
        dispatch(setQueue(updatedData));
        //return updatedData;
    }


    // this function will gather the results of the filter, and then it will break down the params of the filter, sort it into two categories
    // one category will be used to display the filters used in the filter box (this gets sent to 'filtering options') while the other will then populate
    //the filtering options actual search groups which are then used to update or amend the search.
    const getMyFilter = async (params, jump, name, filter) => {

        if (params === 'list') {
            try {
                /**
                 * @type {TaskListPreDefinedFilterType}
                 */
                const filterData = {
                    type: filter.search,
                    timezone: agentInfo.timezone,
                    filterType: 'list',
                }
                dispatch(removeAllFilters())
                dispatch(updatePredefinedFilter({name, params: filterData}))
                dispatch(updatePendingFilters(true))
            } catch (error) {
                setLoading(false);
                console.error("Error fetching data:", error);
            }
        }
        else if (params === 'date') {
            try {
                /**
                 * @type {DatePreDefinedFilterType}
                 */
                const filterData = {
                    date1: filter.first,
                    date2: filter.last,
                    filterType: 'date',
                }
                dispatch(removeAllFilters())
                dispatch(updatePredefinedFilter({name, params: filterData}))
                dispatch(updatePendingFilters(true))
            } catch (error) {
                setLoading(false);
                console.error("Error fetching data:", error);
            }
        }
        else {
            try {
                /**
                 * @type {CustomPreDefinedFilterType}
                 */
                const filterData = {
                    filterId: filter.id,
                    filterType: 'custom',
                }
                dispatch(removeAllFilters())
                dispatch(updatePredefinedFilter({name, params: filterData}))
                dispatch(updatePendingFilters(true))
            } catch (error) {
                setLoading(false);
                console.error("Error fetching data:", error);
            }
        }
    };

    const updateQueue = (queue) => {
        dispatch(setQueue(queue));
        setRefreshQueue(queue[0])
    }


    useEffect(() => {
        if (load) {
            if (load === 'lead') {
                openLead(currentQuery.split("id=")[1])
            }
            else {
                    fetchPage(load, false);
            }
        }
    }, [load,currentQuery,agentAllappointmentData?.data?.length, totalScheduleCall])

    const [sessionStarted, setSessionStarted] = useState(false);

    let intercomInit = false
    useEffect(() => {
        if(isFeature457Enabled===true && !intercomInit && agentInfo.agentId){
            initZendesk(agentInfo);
            intercomInit = true
        }

    }, [agentInfo.agentId])
    return (
        <>
            <div className="App">
                {!agentInfo.agentCode && agentInfo.organization === 'master' && (
                    <InformationPopup agentCode={true} />
                )}
                {queue.length > 0 && appInfo.length > 0 && (
                    <QueueModule maxList={maxList} fetchQueue={fetchQueue} setCallerId={setCallerId} sessionStarted={sessionStarted} setSessionStarted={setSessionStarted} setLeadCard={setLeadCard} setRefreshQueue={setRefreshQueue} refreshQueue={refreshQueue} newAppt={newAppt} setNewAppt={setNewAppt} calledQueue={calledQueue} setCalledQueue={setCalledQueue} expandSession={expandSession} jumpIntoQueue={jumpIntoQueue} replaceQueue={replaceQueue} clearQueue={clearQueue} handlingClearHolding={handlingClearHolding} setHoldingQueue={setHoldingQueue} holdingQueue={holdingQueue} openLead={openLead} handleUpdateQueueLead={handleUpdateQueueLead} searchQueue={searchQueue} textingNumbers={textingNumbers} openQueue={openQueue} expanded={expanded} open={open} myQueue={queue} setMyQueue={updateQueue} addToQueue={addToQueue} setWorkParams={setWorkParams} workParams={workParams} device={twilioDevice} formatDate={timestampConvert} />
                )}
                {subscription.length > 0 && subscription[0].activeSubscription === false && !agentInfo.beta && (
                    <SubscribeModal subscription={subscription} />
                )}
                <LeaderBoard />
                <Conversations setLeadCard={setLeadCard} setNewAppt={setNewAppt} newAppt={newAppt} setLoading={setLoading} setCallerId={setCallerId} setCall={setCall} device={twilioDevice} handleSoftPhone={handleSoftPhone} newMessages={newMessages} unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} />
                <MissedCalls openLead={openLead} />
                <Voicemails openLead={openLead} />
                <HeaderBar fetchPage={fetchPage} signOut={signOut} openLead={openLead} />
                <TopBar expandSession={expandSession} barState={barState} fetchPage={fetchPage} />
                {!page ? (
                    (!isObjectEmpty(activity)) && (
                        <div className="outerWrapper">
                            <div className="twoBlocks" style={{ marginTop: '5px' }}>
                                <div className="frontColumn sideColumn">
                                    <FrontPremadeFilterBlock setRefreshQueue={setRefreshQueue} getMyFilter={getMyFilter} title="My Lists" setMyQueue={updateQueue} setLoading={setLoading} jumpIntoQueue={jumpIntoQueue} />
                                </div>
                                <div className="frontColumn centerColumn">
                                    <QuilityParentBlock expandSession={expandSession} blockType={quilityParentBlockType.LEADS} setLeadCard={setLeadCard} setRefreshQueue={setRefreshQueue} filteredOptions={filteredOptions} textingNumbers={textingNumbers} formatDate={timestampConvert} addToQueue={addToQueue} addSelectedToQueue={addSelectedToQueue} replaceSelectedToQueue={replaceSelectedToQueue} filterOpen={filterOpen} bulkOpen={bulkOpen} jumpIntoQueue={jumpIntoQueue} clearQueue={clearQueue} replaceQueue={replaceQueue} handlingClearHolding={handlingClearHolding} setMyQueue={updateQueue} title='My Leads' nested={[]} data={[]} setHoldingQueue={setHoldingQueue} holdingQueue={holdingQueue} myQueue={queue} openLead={openLead} Additional={EmptyQueue} />
                                </div>
                                <div className="frontColumn sideColumn">
                                <QuilityParentBlock blockType={quilityParentBlockType.BUSINESS} openLead={openLead} setRefreshQueue={setRefreshQueue} size="small" textingNumbers={textingNumbers} unixTommddyyyy={unixTommddyyyy} handleToggle={handleActivityToggle} isToggled={isActivityToggled} nested={['Appointments', 'Scheduled Calls', 'Marketplace']} data={[activity.scheduled, activity.scheduledCalls, marketData]} title='Your Business At a Glance' />
                                    <ConversationPreview title="Recent Conversations" />
                                </div>
                            </div>
                        </div>
                    )
                ) : (page.length > 0 ?
                    <ComponentToRender
                        formatDate={pathTitle === 'Follow Ups' ? unixTommddhia : unixTommddyyyy}
                        title={pathTitle}
                        data={page}
                        fetchPage={fetchPage}
                        openLead={openLead}
                        isMin={isMin}
                        leadCard={leadCard}
                        maxList={maxList}
                        addToQueue={addToQueue}
                        batch={batch}
                    />
                    : null)}
            </div>
            {
                call && callStatus === 'closed' ? (
                    null
                ) : (
                    <SoftPhone call={call} callerId={callerId} callStatus={callStatus} openLead={openLead} setCallStatus={setCallStatus} />
                )
            }
            {leadCard.length > 0 &&
                <div className="leadCardWrapper">
                    <div className="quilityCloseWindow" onClick={() => maxList()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'x-circle-q'} size={34} className="closeIcon 22" adjust="fontello" /></span></div>
                    <LeadCard permission={permission} textingNumbers={textingNumbers} newAppt={newAppt} setNewAppt={setNewAppt} data={leadCard} maxList={maxList} hideBlockMsg={hideBlockMsg} sethideBlockMsg={sethideBlockMsg} setCallerId={setCallerId} setCall={setCall} device={twilioDevice} handleSoftPhone={handleSoftPhone} />
                </div>
            }
            {loading && (
                <div className="loadingScreen">
                    <div className="loaderWrapper">
                        <img src={image} alt="Loading Gif" style={{ width: '100%' }} />
                    </div>
                </div>
            )}
            {refreshLogin && (
                <LoginPopup />
            )}
            {popups.length > 0 && (
                <InformationPopup popups={popups} />
            )}
            {infoAlert && (
                <InfoAlert information={infoAlert} setInfoAlert={setInfoAlert} />
            )}

            {agentInfo.tutorial === 0 && (
                (agentInfo.beta || agentInfo.status) && (
                    <Tutorial />
                )
            )}
            {agentInfo !== '' && isFeature457Enabled===false && (
                <FreshChat
                    token={'ae4a4d16-5a8d-4ab9-90eb-2222b2fed636'}
                    onInit={widget => {
                        widget.user.setProperties({
                            externalId: agentInfo.agentId,
                            email: agentInfo.email,
                            firstName: agentInfo.firstName,
                            lastName: agentInfo.lastName,
                        })
                    }}
                />
            )}

            <ZendeskLauncher></ZendeskLauncher>
        </>
    );
}

export default withAuthenticationRequired(App);
